(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auvrivo-header"] && !Shopify.designMode) return;
  try {
    
function setupAuvrivoHeader(){
 document.querySelectorAll('[data-av-header]').forEach(header=>{
  if(header.dataset.enhanced)return;
  header.dataset.enhanced='true';
  const toggle=header.querySelector('.av-menu-toggle');
  toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));header.classList.toggle('av-mobile-open',!open)});
  header.querySelectorAll('details').forEach(detail=>detail.addEventListener('toggle',()=>{if(detail.open)header.querySelectorAll('details').forEach(other=>{if(other!==detail)other.open=false})}));
  header.addEventListener('keydown',e=>{if(e.key==='Escape'){const open=header.querySelector('details[open]');if(open){open.open=false;open.querySelector('summary').focus()}else{header.classList.remove('av-mobile-open');toggle.setAttribute('aria-expanded','false');toggle.focus()}}});
  document.addEventListener('click',e=>{if(!header.contains(e.target)){header.querySelectorAll('details').forEach(d=>d.open=false);header.classList.remove('av-mobile-open');toggle.setAttribute('aria-expanded','false')}});
 });
}
setupAuvrivoHeader();
document.addEventListener('shopify:section:load',setupAuvrivoHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
